import { ChangeDetectorRef, Component, EventEmitter, Injector, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { EWayService } from '../../e-way/e-way.service';
import { IrnRemarksComponent } from '../irn-remarks/irn-remarks.component';
import { GetEInvoiceModel } from 'src/app/core/models/masters/eway.model';

@Component({
  selector: 'app-e-invoice',
  templateUrl: './e-invoice.component.html',
  styleUrls: ['./e-invoice.component.css']
})
export class EInvoiceComponent {
  protected sessionService: any;
  irnData: GetEInvoiceModel = new GetEInvoiceModel();
  subscriptionEInvoice!: Subscription;
  docData: Object | string = '';
  screenName: string = '';
  reqData: any;
  @Output() emitIrnData = new EventEmitter<any>();
  constructor(private dialog: MatDialog, private injector: Injector,
    private ewayService: EWayService, private cdr: ChangeDetectorRef) {
  }
  ngOnInit(): void {
    this.subscriptionEInvoice = this.ewayService.callEnvoice.asObservable().subscribe((res: any) => {
      if (res) {
        if (this.docData) {
          this.getEinvoiceData(this.docData, this.screenName);
        }
      }
    })
  }

  openRemarksDialog(remarks: string) {
    let irnRemarksDialogRef = this.dialog.open(IrnRemarksComponent, {
      data: {
        remarks: remarks
      },
      panelClass: 'dynamictable'
    });
    irnRemarksDialogRef.afterClosed().subscribe((res: any) => {
    });
  }

  getEinvoiceData(data: any, screen: string) {
    this.screenName = screen;
    let docType = this.screenName.includes('Sales Invoice') ? '13' : '14';
    this.ewayService.getEInvoiceData((data.DocEntry || data.docEntry), docType).subscribe((res: any) => {
      const response = res.value;
      if(res && response.length) {
        this.irnData = response[response.length - 1];
        let IRNGeneratedDate =  this.irnData.U_UTL_IRNGENDT;
        this.irnData.U_UTL_IRNGENDT = IRNGeneratedDate.slice(0, IRNGeneratedDate.indexOf('T'));
        this.emitIrnData.next(this.irnData.U_UTL_IRN);
      }
    })
  }
}
